import './our-team.css'
import cinnamoroll from '../../../static/cinnamon.jfif';
import Steve from '../../../static/Steve.jpeg';
import Lu from '../../../static/Lu.JPG';
import Xinye from '../../../static/Xinye.JPG';
import Yanxi from '../../../static/Xi Yan.JPG';
import Yichi from '../../../static/Yichi.JPG';
import Frank from '../../../static/Frank.PNG';
import Yun from '../../../static/Yun Hou.JPG';
import Sherry from '../../../static/Sherry.JPG';
import Sylvia from '../../../static/Sylvia.jpg';
import Yuhang from '../../../static/Yuhang.jpg';

const Ourteam =() => {
  return(
    <>
    <h3 id="team">Our team</h3>
    <div class="member-container">
      <div class="group1">
      <div class="member"><a href="https://www.linkedin.com/in/sylvia-sun-59ab5b1b5"><img src={Sylvia}/></a><p class="member-name">Sylvia Sun</p> <p class = "position">Product Lead</p></div>
      <div class="member"><a href="https://www.linkedin.com/in/sherry-sheng-9a35711b0"><img src={Sherry}/></a><p class="member-name">Sherry Sheng</p> <p class = "position">Personnel Lead</p></div>
      <div class="member"><a href="https://mastevb.github.io/steve_ma_uwcse.io/"><img src={Steve}/></a><p class="member-name">Steve Ma</p> <p class = "position">Tech Lead</p></div>
      <div class="member"><a href="https://www.linkedin.com/in/lu-song/"><img src={Lu}/></a><p class="member-name">Lu song</p> <p class = "position">UX Design Lead</p></div>
      </div>
      <div class="group2">
      <div class="member"><a href="https://www.linkedin.com/in/frank-yu-8147511a2/"><img src={Frank}/></a><p class="member-name">Frank Yu</p> <p class = "position">Website Engineer</p></div>
      <div class="member"><a href="https://www.linkedin.com/in/yichi-zhang-107bba173/"><img src={Yichi}/></a><p class="member-name">Yichi Zhang</p> <p class = "position">Website Engineer</p></div>
      <div class="member"><a href=""><img src={Yuhang}/></a><p class="member-name">Yuhang Liu</p> <p class = "position">Website Engineer</p></div>
      <div class="member"><a href="https://www.linkedin.com/in/yunhou2000/"><img src={Yun}/></a><p class="member-name">Yun Hou</p> <p class = "position">Website Engineer</p></div>
      </div>
      <div class="group3">
      <div class="member"><a href="https://www.linkedin.com/in/xi-yan-154835195/"><img src={Yanxi}/></a><p class="member-name">Xi Yan</p> <p class = "position">UX Designer</p></div>
      <div class="member"><a href="https://www.linkedin.com/in/yezilixinye/"><img src={Xinye}/></a><p class="member-name">Xinye Li</p> <p class = "position">UX Writer</p></div>
      </div>
    </div>
    <p id="quote">Illustration by Oleg Shcherba from Ouch!</p>
    </>
  )
}

export default Ourteam;